import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../colors';

const Footer = () => {
  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, #B88552, ${colors.racineRedDark})`,
        padding: '30px 0',
        color: '#FFFFFF',
        textAlign: 'center',
        //marginTop: '40px',  // Pushes the footer to the bottom when there is little content
        //paddingTop: '40px', // Ensures there is a gap between the footer and the page content
      }}
    >
      <Typography variant="body2">
        &copy; {new Date().getFullYear()} RacineReview.org. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
